import { createRoot } from "react-dom/client";
import "./index.css";

import { PostHogProvider } from "@posthog/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import posthog from "posthog-js";
import { queryClient } from "./lib/tanstack-query";
import { TRPCProvider, trpcClient } from "./lib/trpc";
import { routeTree } from "./routeTree.gen";

const shouldEnablePostHog = window.location.pathname !== "/session-bridge";

if (shouldEnablePostHog) {
      posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
            api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
            defaults: "2025-05-24",
      });
}
const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
      interface Register {
            router: typeof router;
      }
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
      <PostHogProvider client={posthog}>
            <QueryClientProvider client={queryClient}>
                  <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
                        <RouterProvider router={router} />
                        <ReactQueryDevtools initialIsOpen={false} />
                  </TRPCProvider>
            </QueryClientProvider>
      </PostHogProvider>,
);
